import { initStore } from '@/store'
import { useRouter } from 'next/router'
import { Language } from './enums/language'

/**
 * @description --language--------
 */
export const useCurrentLanguage = () => {
  const router = useRouter()
  const language = Language[initStore().ConfigStore.language]
  const lng = router?.locale === language ? language : router.locale || language
  return {
    language: lng,
  }
}
